export const AsyncStatus = {
  UNINITIALIZED: 'UNINITIALIZED',
  STARTED: 'STARTED',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};